(function () {
    "use strict";
    angular.module("app").factory("tabNavigationService", TabNavigationServiceFactory);

    TabNavigationServiceFactory.$inject = ["$rootScope", "HABIL_EVENTS"];
    function TabNavigationServiceFactory($rootScope, HABIL_EVENTS) {
        const state = {
            current: null,
            IsFlat: false
        };

        return {
            ActivateFlatView: () => {
                state.IsFlat = true;
                $rootScope.$broadcast(HABIL_EVENTS.navigation.tabChanged, state.current);
            },
            IsActive: k => state.IsFlat || state.current === k,
            SetActive: setCurrent,
        };

        function setCurrent(tab) {
            // Sets the current tab
            state.current = tab.key;
            // Broadcast an event which can be used in controllers.
            // Example: when switching tabs in FVMEdit view we auto save the request
            $rootScope.$broadcast(HABIL_EVENTS.navigation.tabChanged, tab);
        }
    }
})();
